// import { qouteStream } from "";
import SearchRepository from "@adapters/features/Search/Repository/Search";
import { qouteStream } from "../../streamerDi";
// import { qouteStream } from "@mainDi";
export default (function (http) {
    return {
        search: new SearchRepository(http),
        quoteStream: qouteStream,
    };
});
